<mat-dialog-content class="loren-asset-details-upload-photo-dialog">
  <div class="loren-asset-details-upload-photo-dialog-main">
    <h4 class="loren-asset-details-upload-photo-dialog-title">
      {{ "asset_details.add_photo_to_gallery" | transloco }} {{ data.assetName }}
    </h4>
    <loren-file-upload
      id="loren-asset-details-upload-photo-dialog-upload-input"
      [label]="'asset_details.choose_photo' | transloco"
      class="loren-asset-details-upload-photo-dialog-upload"
      allowedFileTypes=".png, .jpg, .jpeg"
      [customField]="true"
      [renderAsHidden]="false"
      [fileSizeLimitInMb]="4"
      (fileSizeExceeded)="fileSizeExceededError.set(true)"
      (fileTypeMismatch)="fileTypeMismatchError.set(true)"
      (successfulFileUploadWithNameAndSize)="
        successfulFileUploadHandler($event)
      ">
    </loren-file-upload>
    <p class="loren-asset-details-upload-photo-dialog-helptext">
      {{ "asset_details.files_should_be" | transloco }}
      <span class="text-green">.jpg</span>,
      <span class="text-green">.png</span> {{ "asset_details.or" | transloco }}
      <span class="text-green">.webp</span>
      {{ "asset_details.and" | transloco }}
      <span class="text-bold">
        {{ "asset_details.not_above" | transloco }} 4MB</span
      >.
    </p>
  </div>
  <div class="loren-asset-details-upload-photo-dialog-extra">
    @if(photo()) {
    <div class="centered-between">
      <div
        class="centered-between loren-asset-details-upload-photo-dialog-preview-info">
        <span class="vertically-centered">
          <span class="loren-asset-details-upload-photo-dialog-preview-name">{{
            photo().name
          }}</span>
          ({{ photo().size | lorenNumber : 2 }}MB)
        </span>
        <span>100%</span>
      </div>
      <mat-icon
        class="loren-asset-details-upload-photo-dialog-preview-icon"
        (click)="photo.set(null)">
        close
      </mat-icon>
    </div>
    <img
      class="loren-asset-details-upload-photo-dialog-preview-image"
      width="100%"
      alt="Preview"
      [src]="photo().file" />
    } @if(fileSizeExceededError() || fileTypeMismatchError()) {
    <div class="loren-asset-details-upload-photo-dialog-error">
      <mat-icon svgIcon="no_data"></mat-icon>
      @if(fileTypeMismatchError()) {
      {{ "asset_details.file_type_not_allowed" | transloco }}
      } @else if(fileSizeExceededError()) {
      {{ "asset_details.file_size_exceeded" | transloco }} }
    </div>
    }
    <mat-form-field
      appearance="outline"
      class="loren-asset-details-upload-photo-dialog-status">
      <mat-label>{{ "asset_details.choose_status" | transloco }}</mat-label>
      <mat-select [value]="status()" (valueChange)="status.set($event)">
        @for(status of statuses; track status) {
        <mat-option [value]="status">{{
          "statuses." + status.toLowerCase() | transloco
        }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="loren-asset-details-upload-photo-dialog-comment">
      <mat-label>{{ "asset_details.add_comment" | transloco }}...</mat-label>
      <textarea
        matInput
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="5"
        cdkAutosizeMaxRows="10"
        [value]="comment()"
        (change)="comment.set($event.target.value)"></textarea>
    </mat-form-field>
  </div>
  <mat-dialog-actions class="loren-asset-details-upload-photo-dialog-actions">
    <button matButton="filled" class="btn-secondary" (click)="onCancel()">
      {{ "asset_details.cancel" | transloco }}
    </button>
      <button
              matButton="filled"
              [mat-dialog-close]="{
        assetCondition: status(),
        comment: comment(),
        photo: photo()
      }">
          {{ "asset_details.save" | transloco }}
      </button>
  </mat-dialog-actions>
</mat-dialog-content>
